import { z } from 'zod';

import {
  ENTRY_TRACKING_CONTENT_MAX_LENGTH,
  ENTRY_TRACKING_SOURCES,
} from '../../../helpers/entryTracking';

const EntryTrackingValidatorSchema = z.object({
  source: z.enum(ENTRY_TRACKING_SOURCES),
  content: z.string().max(ENTRY_TRACKING_CONTENT_MAX_LENGTH).nullish(),
});

export const JoinWaitingListValidatorSchema = z.object({
  numberOfSeats: z.number(),
  numberOfParkingTickets: z.number(),
  pickedSeatsId: z.array(z.string()).optional(),
  entryTracking: EntryTrackingValidatorSchema.optional(),
});

export type JoinWaitingListValidator = z.infer<
  typeof JoinWaitingListValidatorSchema
>;
